import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from '../auth/auth.guard';
import { MasterComponent } from '../layout/pages/master/master.component';
import { DashboardGuard } from './dashboard.guard';
var ɵ0 = {
    showHeader: true
};
var routes = [
    {
        path: 'dashboard',
        component: MasterComponent,
        canActivate: [AuthGuard, DashboardGuard],
        data: ɵ0,
        children: [
            {
                path: '',
                component: DashboardComponent
            }
        ]
    }
];
var DashboardRoutingModule = /** @class */ (function () {
    function DashboardRoutingModule() {
    }
    return DashboardRoutingModule;
}());
export { DashboardRoutingModule };
export { ɵ0 };
